/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const Update_Band = gql`
  mutation UpdateBand($filter: BandFilter, $update: updateBandInput) {
    updateBand(filter: $filter, update: $update) {
      bandId
      bandName
      bandLogo
      profileUpdateChange
      isChangeCostumeEnabled
      bandLogo
      primaryTheme
      secondaryTheme
      isUpdateExpiryEnabled
      inviteExpireTime
      partialRemainderEmailTriggerTime
      isMultiplePurchase
      openRegEnabled
      isPartialRemainderEmailTriggerEnabled
      unPaidRemainderEmailTriggerTime
      isUnPaidRemainderEmailTriggerEnabled
      unPaidRemainderExcludedEmails
      partialRemainderExcludedEmails
      isPlatformFeeEnabled
      platformFeePercent
      isPaymentExpiryEnabled
      paymentExpireTime
      isLimitedFieldsSignUpEnabled
    }
  }
`;
